module.exports = __webpack_public_path__ + "img/statistics-presentation.90a16358.png";